export default __webpack_public_path__ + "static/media/faq-bg.2c6bafeb.png";